module.exports = __webpack_public_path__ + "img/UnitedArabEmirates.08a2f7c3.png";